import { MarketingButton, MarketingLink } from "@/components/marketing/marketing-action"
import { SectionEyebrow } from "@/components/marketing/section-eyebrow"

interface ErrorFallbackContentProps {
  description?: string
  digest?: string
  eyebrow?: string
  reset: () => void
  showHomeLink?: boolean
}

export function ErrorFallbackContent({
  description = "We tried to capture the error automatically. Try the action again, or return home and include the reference below if you contact support.",
  digest,
  eyebrow = "Something broke on this page",
  reset,
  showHomeLink = true,
}: ErrorFallbackContentProps) {
  return (
    <main className="flex min-h-[60vh] items-center justify-center px-6 py-12 text-[var(--color-ink)]">
      <div className="flex max-w-[30rem] flex-col items-center text-center">
        <SectionEyebrow size="sm">{eyebrow}</SectionEyebrow>
        <h1 className="serious-display mt-4 text-balance text-[clamp(1.6rem,3vw,2.1rem)] leading-[1.1] text-[var(--color-ink)]">
          Something went wrong.
        </h1>
        <p className="mt-4 text-[1rem] leading-[1.6] text-[var(--color-ink-muted)]">
          {description}
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <MarketingButton type="button" onClick={reset} size="lg">
            Try again
          </MarketingButton>
          {showHomeLink ? (
            <MarketingLink href="/" variant="secondary" size="lg">
              Home
            </MarketingLink>
          ) : null}
        </div>
        {digest ? (
          <p className="mt-6 select-all font-mono text-[0.75rem] leading-[1.5] text-[var(--color-ink-soft)]">
            Error reference: {digest}
          </p>
        ) : null}
      </div>
    </main>
  )
}
